export const specific = {
    name: 'rftngpay',
    email: 'support@enjoyfamilycooking.com',
    phone: '+372 8803317',
};

export const baseUrl = 'https://enjoyfamilycooking.com/';
